import * as yup from 'yup'

export const schema = yup.object({
    email: yup.string().required(),
    country: yup.string().required(),
    language: yup.string().required(),
    phone: yup.string().required(),
    fraudulent: yup.string().required(),
    referralAwarded: yup.string().required(),
})
